import React from "react";
import { FaRocket, FaExternalLinkAlt } from "react-icons/fa";

function ClientLaunches({ sites }) {
  return (
    <div className="launch-manifest">
      <div className="launch-manifest-header">
        <span>MISSION</span>
        <span className="launch-manifest-header-status">STATUS</span>
      </div>
      {sites.map((site, i) => (
        <a
          key={site.domain}
          href={site.url}
          target="_blank"
          rel="noreferrer"
          className="launch-row"
          style={{ "--row-delay": `${i * 0.06}s` }}
          aria-label={`Visit ${site.title} (opens in a new tab)`}
        >
          <span className="launch-row-rocket">
            <FaRocket />
          </span>
          <span className="launch-row-info">
            <span className="launch-row-domain">{site.domain}</span>
            <span className="launch-row-category">{site.category}</span>
          </span>
          <span className="launch-row-status">
            <span className="launch-status-dot" />
            LIVE
          </span>
          <span className="launch-row-arrow">
            <FaExternalLinkAlt />
          </span>
        </a>
      ))}
    </div>
  );
}

export default ClientLaunches;
